import { render, staticRenderFns } from "./beneficiaryInfo.vue?vue&type=template&id=cf163a64"
import script from "./beneficiaryInfo.vue?vue&type=script&lang=js"
export * from "./beneficiaryInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports